module.exports = __webpack_public_path__ + "46ddeb4359a0a75bc4e08190a5862909.woff";